import { createAction } from '@reduxjs/toolkit';
import { IAuthDwhData } from 'reactApp/modules/dwh/dwh.types';

export const sendAuthDwhRequest = createAction<IAuthDwhData>('dwh/sendAuthDwhRequest');
